export default "__VITE_ASSET__F1QkFK5v__"